<template>
  <div class='bottom'>
    <div class="bottomContent">
    <div class="menuLine">
      <div class="memuCon"> <Menu></Menu></div>

    </div>
      <ul class='address'>
        <li class='name'>
          <p>辽宁思凯科技股份有限公司</p>
          <p class='en'>Liaoning SC Technology Co., Ltd</p>
        </li>
        <li class='bottomAdd'>
          <p>地　　址：辽宁省丹东市江湾工业区C区黄海大街14号</p>
          <p>联系电话：0415-3151611/0415-3144734　<span>   传　　真：0415-3144109</span></p>　　　
          <p>E － mail：ddsce@mail.ddphtt.ln.cn　<span>邮　　编：118002</span></p>

        </li>
      </ul>
    </div>
    <div class='copy'>
      <p>copyright 2024 - 辽宁思凯科技股份有限公司 - </p>
      <p>&nbsp辽ICP备08003004号&nbsp</p>
    </div>
  </div>

</template>

<script>
import Menu from '../components/Menu.vue'

export default {
  name: 'Bottom',
  components: {
    Menu
  },

  props: {
    // msg: String
  }
}
</script>

<style>
a {
  text-decoration: none;
  color: #fff;
}

/* 在这里添加针对手机屏幕的样式 */
.bottom {
  background-color: #333;
  color: #fff;
  display: flex;
  flex-direction: column;
}
.bottomContent {
  width: 84%;
  margin: 6vw auto;
}
.address {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.name {
  font-size: 4.5vw;
  line-height: 5vw;
  padding-left: 18vw;
  background-image: url(../assets/logobot@2x.png);
  background-repeat: no-repeat;
  background-size: 16vw;
  background-position: left center;
  margin-top: 4vw;
  margin-bottom: 8vw;
}

.en {
  font-size: 3vw;

}
.bottomAdd {
  font-size: 3.5vw;
  line-height: 6vw;
  padding-bottom: 10px;
}
.bottomAdd p {
  margin-top: 0;
  display: flex;
  flex-direction: column;
}
.copy {
  border-top:1px solid rgba(255,255,255,.3);
  padding-top: 2vw;
  background-color: #000;
  line-height: 6vw;
  font-size: 3vw;
  display: flex;
  flex-direction: column;
}


@media (min-width: 768px) {
  .bottomContent {
    width: 680px;
    margin: 15px auto 30px auto;
  }
  .menuLine {
    padding-bottom: 10px;
    border-bottom: rgba(255,255,255,0.2) solid 1px;
  }
  .address {

  }

  .address li p span {
    display: inline;
  }

  .name {
    font-size: 20px;
    line-height: 20px;
    /*padding-top: 5px;*/
    padding-left: 75px;
    margin-bottom: 30px;
    background-image: url(../assets/logobot@2x.png);
    background-repeat: no-repeat;
    background-size: 70px;
  }

  .en {
    font-size: 14px;
  }
  .bottomAdd {
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 0;
  }
  .bottomAdd p {
    margin-top: 0;
    display: flex;
    flex-direction: row;
  }
.copy {
  padding-top: 10px;
  padding-bottom: 5px;
  font-size: 16px;
  line-height: 40px;
  display: flex;
  flex-direction:row;
  justify-content:center;
}
}
@media (min-width: 960px) {
  .bottomContent {
    width: 900px;
  }
  .memuCon {
    width: 80%;
  }
  .address {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    padding-top: 50px;
    padding-bottom: 10px;
  }

  .name {
    flex-grow: 0;
    margin-bottom: 10px;
    margin-top: 20px;
  }
}

@media (min-width: 1200px) {
  .bottom {
  }

  .bottomContent {
    width: 1200px;
  }
.memuCon {
  width: 70%;
}
  .address {
    padding-left: 0;
    padding-right: 0;
  }

  .name {
    font-size: 24px;
    line-height: 28px;
    padding-left: 100px;
    margin-top: 20px;
    background-image: url(../assets/logobot@2x.png);
    background-repeat: no-repeat;
    background-size: 90px;
    background-position: left center;
  }

  .en {
    font-size: 16px;
  }
  .copy {
    /*justify-content:right;*/
  }
}
</style>